//vesting

import React, { useContext, useState } from "react";
import { get, isEmpty, isUndefined } from "lodash";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  FieldInput,
  FieldButtonGroup,
  FieldTextarea,
  FieldDropSide,
  SearchableList,
  AddPlans,
  AddButton,
  Link,
  CsplTable as Table,
  FieldInputNumber,
  FieldMultiSelectButtonGroup,
  MultiSelectDropdown,
  DropdownWithImage,
  LoaderWrapper,
  DeleteWarning,
} from "../../../components";
import {
  ROUTES,
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  yesNoOptions,
  required,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  getNumber,
  transformToMultiselectSave,
  toMultiSelectValueById,
  getAdvancedPathWithParam,
  clearFieldValues,
  getParamsFromQueryString,
} from "../../../utils";
import {
  createPlanStore,
  savePlanDetailsAction,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
  setManagePageLevelData,
  setManagePlanFlow,
  clearLocalCacheByModel,
} from "../../../contexts";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import {
  getEmployerSourcesList,
  GetplanYos,
  getVesting,
  listInvestment,
  listVesting,
  saveVesting,
  getEmploymentStatusList,
  listFunding,
  deleteVesting,
} from "../../../services";
import excludedYears from "../../../mocks/vestingExcludedYear.json";
import timingForfeitures from "../../../mocks/vestingTimingForfeitures.json";
import defaultInvestments from "../../../mocks/vestingDefaultInvestments.json";
import CommonVestingRules from "./CommonVestingRules";
import { useEffect } from "react";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const initialValues = {};

const columns = [
  {
    label: "Vesting Description",
    className: "column-addtional-vesting-description",
    columnName: "vestingDescription",
    link: MANAGE_PLAN_ROUTES.ADD_VESTING_RULE,
  },
];
const AddVestingContainer = (props) => {
  const { history } = props;
  const location = useLocation();
  const { state, dispatch } = useContext(createPlanStore);
  const { planId, flow, vestingId } = useRouterParams();
  const dirtyCheck = getParamsFromQueryString("dirtyCheck");
  const formName = managePlanFormNames.ADD_VESTING;
  const fields = formFields[formName];
  const apiData = get(state, "api.data")
    ? get(state, "api.data")
    : get(state, "api.reviewAndPlanDetail");

  // const vestingsApiData = get(apiData, "vestings", []);
  const vestingsListData = get(state, "vestings", []); // to be removed
  const companyId = get(apiData, "companyId");
  const [vestings, setVestings] = useState([]);
  const [forfeitureTreatment, setForfeitureTreatment] = useState([]);
  const { response: getPlanYosDataInVesting, loading: yosLoading } = useRequest(
    {
      method: GetplanYos,
      payload: planId,
      defaultResponse: [],
    }
  );
  const intVestingId = parseInt(vestingId);

  useEffect(() => {
    listVesting(planId).then((response) => {
      setVestings(response);
    });
    listFunding(planId).then((response) => {
      if (response?.funding?.forfeitureAccountEnabled)
        setForfeitureTreatment(
          toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.FORFEITURE_ENABLED_FORFEITURE_TREATMENT
          )
        );
      else
        setForfeitureTreatment(
          toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.FORFEITURE_TREATMENTS)
        );
    });
  }, []);

  const { response: vesting, loading: vestingLoading } = useRequest({
    method: getVesting,
    payload: parseInt(vestingId),
    defaultResponse: {},
  });
  // const { response: vestings } = useRequest({
  //   method: listVesting,
  //   payload: planId,
  //   defaultResponse: [],
  // });
  const [employmentStatusList, setEmploymentStatusList] = useState([]);
  useDeepEffect(() => {
    if (companyId > 0) {
      getEmploymentStatusList(companyId).then((response) => {
        setEmploymentStatusList(response);
      });
    }
  }, [companyId]);
  const [showWarning, setShowWarning] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const DeleteToastMessage = "You are attempting to delete the Vesting Rule.";
  const DeleteToastMessageHead = "Delete Vesting Rule?";

  const vestingsApiData = get(vestings, "vestings", []);
  const formValues = get(vesting, "vesting", {});
  const yosValue = get(getPlanYosDataInVesting, "planYOS", {});
  const vestingsLocalCache = get(state, "vestings", []);
  const localStateOfcurrentVesting = Array.isArray(vestingsLocalCache)
    ? vestingsLocalCache
        .filter((x) => x !== undefined)
        .find((_) => _.id == parseInt(vestingId))
    : {};
  const additionalVestingsData =
    localStateOfcurrentVesting != undefined
      ? localStateOfcurrentVesting?.additionalVestings
      : get(formValues, "additionalVestings", []);
  const vestingMethod = get(formValues, "usePlanDefaultYOSIndicator")
    ? get(yosValue, "serviceComputation")
    : get(formValues, "vestingMethod");
  const [sourceList, setSourceList] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessages] = useState([]);
  const [investmentsList, setInvestmentList] = useState([]);
  const [selectedSource, setSelectedSource] = useState([]);

  useDeepEffect(() => {
    !isEmpty(formValues) &&
      !isEmpty(formValues[fields.employerSourcesList]) &&
      setSelectedSource(
        get(formValues, fields.employerSourcesList, [])?.map(
          (val) => val.sourceId
        )
      );
  }, [formValues]);

  useDeepEffect(() => {
    getEmployerSourcesList(planId).then((response) => {
      setSourceList(
        response.map((val) => ({
          label: val.name,
          value: val.id,
        }))
      );
    });
  }, [sourceList]);
  useDeepEffect(() => {
    listInvestment(planId).then((response) => {
      if (response?.investmentPlanMappings) {
        setInvestmentList(
          response.investmentPlanMappings.map((investment) => ({
            value: investment.id,
            label: investment.name,
          }))
        );
      }
    });
  }, []);
  const vestingSourceList = vestingsApiData
    .filter((vesting) => vesting.id != get(formValues, "id", 0))
    .map((vesting) => vesting["employerSourcesList"])
    .reduce(
      (previous, current) => [
        ...previous,
        ...current.reduce((prev, curr) => [...prev, curr["sourceId"]], []),
      ],
      []
    );
  const vestingSourcesList = sourceList.filter(
    (source) => !vestingSourceList.includes(source.value)
  );

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.VESTING,
        pathParam: [flow, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      onClick: () => {
        if (
          !location.pathname?.includes(
            MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION
          )
        )
          dispatch(clearLocalCacheByModel("vestings"));
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.VESTING,
        pathParam: [flow, planId],
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADD_VESTING,
            pathParam: [FLOW_TYPES.SAVE, planId, vestingId],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => setShowWarning(true),
    },
  ];
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleConfirmClick = () => {
    const payload = {
      vestingId: parseInt(vestingId),
      planId: parseInt(planId),
      sourceList: selectedSource.toString(),
    };
    deleteVesting(payload)
      .then((response) => {
        if (response.isSuccessful) {
          setShowWarning(false);
          history.push(
            getAdvancedPathWithParam({
              path: MANAGE_PLAN_ROUTES.VESTING,
              pathParam: [FLOW_TYPES.EDIT, planId],
            })
          );
          dispatch(
            setManagePlanToastInfo({
              showToast: true,
              toastMessage: "Data deleted successfully",
            })
          );
        } else {
          setShowWarning(false);
          var x = response.errorMessages;
          if (
            //x[0].controlName == null &&
            x[0].errorCode !== null &&
            x[0].message !== null
          ) {
            setErrorMsg(`${x[0].errorCode} : ${x[0].message}`);
          }
          setShowErrorModal(true);
        }
      })
      .catch((error) => {
        //Handle Errors
      });
  };
  const handleClose = () => {
    setShowErrorModal(false);
  };

  const getDataForSave = (values) => {
    const updatedValues = {
      ...formValues,
      ...values,
      id: isNaN(intVestingId) ? 0 : intVestingId,
      planId: planId,
      // description: values[fields.vestingDescription],
      // name: values[fields.vestingName] || undefined,
      // method: values[fields.vestingMethod] || undefined,
      // schedule: values[fields.vestingSchedule] || undefined,
      vestingMethod: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.vestingMethod],
      elapsedTime: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.elapsedTime],
      hoursOfService:
        values[fields.applyToAllStatuses] &&
        values[fields.usePlanDefaultYOSIndicator]
          ? null
          : getNumber(values[fields.hoursOfService]),
      vestingComputationalPeriod: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.vestingComputationalPeriod],
      serviceCreditPeriod: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.serviceCreditPeriod],
      activeEmployees:
        values[fields.applyToAllStatuses] &&
        values[fields.usePlanDefaultYOSIndicator]
          ? null
          : values[fields.activeEmployees],
      daily: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.daily],
      weekly: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.weekly],
      biWeekly: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.biWeekly],
      semiMonthly: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.semiMonthly],
      monthly: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.monthly],
      quarterly: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.quarterly],
      semiAnnually: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.semiAnnually],
      annually: values[fields.usePlanDefaultYOSIndicator]
        ? null
        : values[fields.annually],

      forfeitureFundIn: values[fields.forfeitureFundIn],
      vestingScheduleTable: values[fields.immediateVestingIndicator]
        ? undefined
        : {
            [fields.firstYear]: parseFloat(values[fields.firstYear]),
            [fields.secondYear]: parseFloat(values[fields.secondYear]),
            [fields.thirdYear]: parseFloat(values[fields.thirdYear]),
            [fields.fourthYear]: parseFloat(values[fields.fourthYear]),
            [fields.fifthYear]: parseFloat(values[fields.fifthYear]),
            sixthYear: 100,
          },

      [fields.disregardYearsOfServiceAfterHowManyBreakInService]: getNumber(
        values[fields.disregardYearsOfServiceAfterHowManyBreakInService]
      ),
      [fields.freezeVestingPercentageAfterHowManyBreakInService]: getNumber(
        values[fields.freezeVestingPercentageAfterHowManyBreakInService]
      ),
      additionalVestings: additionalVestingsData?.map((item) => {
        return {
          ...item,
        };
      }),
      [fields.employerSourcesList]: [
        ...transformToMultiselectSave(
          (values[fields.employerSourcesList] || []).filter(
            (val) =>
              !get(formValues, fields.employerSourcesList, [])
                .map((_) => _.sourceId)
                .includes(val)
          ),
          "sourceId"
        ),
        ...get(formValues, fields.employerSourcesList, [])?.map((val) => ({
          ...val,
          isDeleted: !(values[fields.employerSourcesList] || []).includes(
            val.sourceId
          ),
        })),
      ],
      applyToAllStatuses: values[fields.applyToAllStatuses],
      hoursOfServiceForEmploymentStatus:
        !values[fields.applyToAllStatuses] && values[fields.vestingMethod] == 1
          ? values?.hoursOfServiceForEmploymentStatus
          : !isEmpty(formValues?.hoursOfServiceForEmploymentStatus)
          ? formValues?.hoursOfServiceForEmploymentStatus?.map((item) => ({
              ...item,
              isDeleted: true,
            }))
          : [],
      equivalencyHoursForEmploymentStatus:
        !values[fields.applyToAllStatuses] && values[fields.vestingMethod] == 3
          ? values?.equivalencyHoursForEmploymentStatus
          : !isEmpty(formValues?.equivalencyHoursForEmploymentStatus)
          ? formValues?.equivalencyHoursForEmploymentStatus?.map((item) => ({
              ...item,
              isDeleted: true,
            }))
          : [],
    };

    return updatedValues;
  };
  const [isLoading, setIsLoading] = useState(false);
  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setIsLoading(true);
    saveVesting(getDataForSave(values)).then((response) => {
      if (response.isSuccessful) {
        dispatch(
          setManagePlanFlow({
            planId: planId,
          })
        );
        dispatch(
          setManagePageLevelData({
            formName: formName,
            fieldData: values,
          })
        );
        history.push(
          getPathWithParam({
            path: MANAGE_PLAN_ROUTES.VESTING,
            pathParam: [flow, planId], // put the company id after crated
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
        dispatch(clearLocalCacheByModel("vestings"));
      } else {
        setSubmitting(false);

        console.log(values, formValues);
        setErrorMessages([]);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          if (_.controlName === "errorMessage") {
            setErrorMessages([`${_.errorCode} : ${_.message}`]);
          }
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
      setIsLoading(false);
    });
  };
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const isYOSApplicable = getPlanYosDataInVesting?.planYOS?.isPlanYOSApplicable;
  return (
    <Formik
      initialValues={{
        ...initialValues,
        [fields.vestingDescription]: get(formValues, "vestingDescription"),
        [fields.usePlanDefaultYOSIndicator]: isEdit
          ? isYOSApplicable
          : isUndefined(isYOSApplicable) || !isYOSApplicable
          ? false
          : null,
        [fields.yearsOfServiceExcludedIndicator]: false,
        [fields.immediateVestingIndicator]: true,
        [fields.vestingPastPeriodComputation]: false,
        [fields.breakInServiceApplicable]: false,
        ...formValues,
        [fields.vestingName]: get(formValues, "vestingName"),
        [fields.vestingMethod]: vestingMethod,
        [fields.elapsedTime]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "elapsedTimeInMonths")
          : get(formValues, "elapsedTime"),
        [fields.hoursOfService]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "hoursOfService")
          : get(formValues, "hoursOfService"),
        [fields.vestingComputationalPeriod]: get(
          formValues,
          "usePlanDefaultYOSIndicator"
        )
          ? get(yosValue, "computationPeriod")
          : get(formValues, "vestingComputationalPeriod"),
        [fields.serviceCreditPeriod]: get(
          formValues,
          "usePlanDefaultYOSIndicator"
        )
          ? get(yosValue, "planYOSServiceCreditPeriod")
          : get(formValues, "serviceCreditPeriod"),
        [fields.activeEmployees]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "activeEmployeesHours")
          : get(formValues, "activeEmployees"),
        [fields.daily]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "dailyHours")
          : get(formValues, "daily"),
        [fields.weekly]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "weeklyHours")
          : get(formValues, "weekly"),
        [fields.biWeekly]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "biWeeklyHours")
          : get(formValues, "biWeekly"),
        [fields.semiMonthly]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "semiMonthlyHours")
          : get(formValues, "semiMonthly"),
        [fields.monthly]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "monthlyHours")
          : get(formValues, "monthly"),
        [fields.quarterly]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "quarterlyHours")
          : get(formValues, "quarterly"),
        [fields.semiAnnually]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "semiAnnuallyHours")
          : get(formValues, "semiAnnually"),
        [fields.annually]: get(formValues, "usePlanDefaultYOSIndicator")
          ? get(yosValue, "annuallyHours")
          : get(formValues, "annually"),

        [fields.vestingSchedule]: get(formValues, "vestingSchedule"),
        [fields.firstYear]: get(formValues, "vestingScheduleTable.firstYear"),
        [fields.secondYear]: get(formValues, "vestingScheduleTable.secondYear"),
        [fields.thirdYear]: get(formValues, "vestingScheduleTable.thirdYear"),
        [fields.fourthYear]: get(formValues, "vestingScheduleTable.fourthYear"),
        [fields.fifthYear]: get(formValues, "vestingScheduleTable.fifthYear"),
        [fields.employerSourcesList]: get(
          formValues,
          fields.employerSourcesList,
          []
        )?.map((val) => val.sourceId),
        [fields.applyToAllStatuses]: get(
          formValues,
          "usePlanDefaultYOSIndicator"
        )
          ? get(yosValue, "applyToAllStatuses")
          : get(formValues, "applyToAllStatuses", true),
        hoursOfServiceForEmploymentStatus:
          vestingMethod == 1
            ? get(formValues, "hoursOfServiceForEmploymentStatus", [])
            : [],
        equivalencyHoursForEmploymentStatus:
          vestingMethod == 3
            ? get(formValues, "equivalencyHoursForEmploymentStatus", [])
            : [],
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        setTouched,
        setSubmitting,
        values,
        dirty,
        ...rest
      }) => {
        const handleVestingFieldChange = (value) => {
          setValues({
            ...clearFieldValues({
              values,
              fieldsToClear: [fields.vestingAgeLimit, fields.excludedYears],
            }),
            [fields.yearsOfServiceExcludedIndicator]: value,
          });
          setTouched({
            [fields.vestingAgeLimit]: false,
            [fields.excludedYears]: false,
          });
        };
        const addVestingRuleClick = () => {
          setSubmitting(true);
          const updatedData = getDataForSave(values);
          const newVestingId =
            vestingId === undefined ? vestingId + 1 : vestingId;
          dispatch(
            setManagePlanLocalCache({
              model: "vestings",
              data: updatedData,
            })
          );
          window.setTimeout(
            () =>
              history.push(
                getPathWithParam({
                  path: MANAGE_PLAN_ROUTES.ADD_VESTING_RULE,
                  pathParam: [
                    FLOW_TYPES.ADD,
                    planId,
                    newVestingId,
                    additionalVestingsData?.length,
                  ], // put the company id after crated
                  queryParam: `?dirtyCheck=${dirty}`,
                })
              ),
            10
          );
        };
        const editVestingRuleClick = (item, index) => {
          setSubmitting(true);
          var updatedVestingList;
          const updatedData = getDataForSave(values);
          if (isEmpty(formValues)) {
            updatedVestingList = [...vestingsApiData, updatedData];
          } else {
            updatedVestingList = vestingsApiData?.map((item, index) => {
              if (item.id === parseInt(vestingId)) {
                return { ...item, ...updatedData };
              }
              return item;
            });
          }
          dispatch(
            setManagePlanLocalCache({
              model: "vestings",
              data: updatedVestingList,
            })
          );
          window.setTimeout(() => {
            history.push(
              getPathWithParam({
                path: item.link,
                pathParam: [FLOW_TYPES.EDIT, planId, vestingId, index], // put the company id after crated
              })
            );
          }, 10);
        };
        const immediateVestingIndicator =
          values[fields.immediateVestingIndicator];
        return (
          <LoaderWrapper isLoading={yosLoading || vestingLoading || isLoading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={flow}
                dirtyFlagCheck={dirtyCheck}
              >
                <p className="plan-sub-heading">Vesting Details</p>
                <Row>
                  <div className="vestingsource-warning">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      className="warning-symbol"
                    />
                    <p className="warning-text">
                      Any Source that is not mapped to any of the Vesting rules
                      in the Plan will be considered as 100% Immediately Vested.
                    </p>
                  </div>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      size="md"
                      name={fields.vestingName}
                      label={"Vesting Name"}
                      value={values[fields.vestingName]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                      isRequired
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Field
                      name={fields.vestingDescription}
                      label="Vesting Description"
                      autoComplete="off"
                      value={values[fields.vestingDescription]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldTextarea}
                      size="lg"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      size="sm"
                      name={fields.yearsOfServiceExcludedIndicator}
                      label={"Years of Service Excluded?"}
                      options={yesNoOptions}
                      selectedValue={
                        values[fields.yearsOfServiceExcludedIndicator]
                      }
                      type="text"
                      autoComplete="off"
                      value={values[fields.yearsOfServiceExcludedIndicator]}
                      onChange={handleVestingFieldChange}
                      onSelect={(value) => {
                        setValues({
                          ...values,
                          [fields.yearsOfServiceExcludedIndicator]: value,
                        });
                      }}
                      isRequired
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      size="md"
                      isRequired
                      label="Select applicable sources for Vesting rules"
                      name={fields.employerSourcesList}
                      value={toMultiSelectValueById(
                        values[fields.employerSourcesList],
                        vestingSourcesList
                      )}
                      disabled={isEdit && !isSave}
                      options={vestingSourcesList}
                      isMultiSelect
                      popupContent={
                        vestingSourcesList != 0 ? (
                          <MultiSelectDropdown
                            label={
                              vestingSourcesList.length === 0
                                ? "No data available"
                                : "Select applicable sources"
                            }
                            name={fields.employerSourcesList}
                            onSelect={(value) => {
                              setFieldValue(fields.employerSourcesList, value);
                              setSelectedSource(value);
                            }}
                            value={values[fields.employerSourcesList]}
                            options={vestingSourcesList}
                            disabled={isEdit && !isSave}
                          />
                        ) : (
                          <DropdownWithImage
                            label="Select Applicable sources for Vesting rules"
                            name={fields.employerSourcesList}
                            value={values[fields.employerSourcesList]}
                            disabled={isEdit && !isSave}
                          />
                        )
                      }
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>

                {values[fields.yearsOfServiceExcludedIndicator] === true ? (
                  <Row>
                    <Col md="4">
                      <Field
                        size="md"
                        label="Excluded Years"
                        name={fields.excludedYears}
                        value={values[fields.excludedYears]}
                        options={excludedYears.data}
                        disabled={isEdit && !isSave}
                        popupContent={
                          <SearchableList
                            label="Select Excluded Years definition"
                            isNotTypeAhead
                            options={excludedYears.data}
                            onSelect={(value) => {
                              setValues({
                                ...clearFieldValues({
                                  values,
                                  fieldsToClear: [fields.vestingAgeLimit],
                                }),
                                [fields.excludedYears]: value,
                              });
                            }}
                            selectedValue={values[fields.excludedYears]}
                            isRadio
                          />
                        }
                        isRequired
                        component={FieldDropSide}
                      />
                    </Col>
                  </Row>
                ) : null}

                {values[fields.yearsOfServiceExcludedIndicator] === true &&
                (values[fields.excludedYears] === 1 ||
                  values[fields.excludedYears] === 3) ? (
                  <Row>
                    <Col md="4">
                      <Field
                        size="xs"
                        isRequired
                        name={fields.vestingAgeLimit}
                        label="Vesting Age Limit"
                        value={values[fields.vestingAgeLimit]}
                        disabled={isEdit && !isSave}
                        onChange={handleChange}
                        component={FieldInputNumber}
                        type="number"
                        autoComplete="off"
                        min={1}
                        max={99}
                      />
                    </Col>
                  </Row>
                ) : null}
                <p className="py-3 plan-sub-heading">Default Vesting Rule</p>
                <CommonVestingRules
                  fields={fields}
                  isEdit={isEdit}
                  isSave={isSave}
                  usePlanDefaultYOSIndicator={
                    formValues?.usePlanDefaultYOSIndicator
                  }
                  getPlanYosDataInVesting={getPlanYosDataInVesting}
                  errorMessage={errorMessage}
                  statusList={employmentStatusList}
                />
                {immediateVestingIndicator === false && (
                  <>
                    {/* <h4 className="ft-20 py-3">Break In Service & Termination</h4> */}
                    <h4 className="ft-20 py-3">Forfeitures</h4>
                    {/* <Field
                    size="sm"
                    name={fields.breakInServiceApplicable}
                    label={"Years of Service Applicable?"}
                    options={yesNoOptions}
                    selectedValue={values[fields.breakInServiceApplicable]}
                    value={values[fields.breakInServiceApplicable]}
                    onChange={(value) => {
                      setValues({
                        ...values,
                        [fields.breakInServiceApplicable]: value,
                        [fields.breakInServiceRules]: null,
                      });
                    }}
                    component={FieldButtonGroup}
                    disabled={isEdit && !isSave}
                    isRequired
                  />
                  {values[fields.breakInServiceApplicable] === true && (
                    <>
                      <Field
                        size="xs"
                        name={fields.hours}
                        label={"Break in service Definition"}
                        value={values[fields.hours]}
                        type="number"
                        onChange={handleChange}
                        hasSuggestion
                        suggestionDefaultText="Hours"
                        disabled={isEdit && !isSave}
                        component={FieldInputNumber}
                        min={0}
                        max={9999}
                        isRequired
                      />
                      <Field
                        size="md"
                        name={fields.breakInServiceRules}
                        label={"Break in Service Rules"}
                        options={toOptionValuesFromMapper(
                          OPTIONS_DATA_MAPPER.BASIC_SERVER_RULES
                        )}
                        selectedValue={values[fields.breakInServiceRules]}
                        value={values[fields.breakInServiceRules]}
                        onChange={(value) => {
                          setValues({
                            ...values,
                            [fields.breakInServiceRules]: value,
                          });
                        }}
                        component={FieldButtonGroup}
                        disabled={isEdit && !isSave}
                        isRequired
                      />
                    </>
                  )}
                  {values[fields.breakInServiceRules] === 2 && (
                    <Field
                      size="sm"
                      name={
                        fields.disregardYearsOfServiceAfterHowManyBreakInService
                      }
                      label={
                        "Disregard prior service after how many consecutive breaks in service"
                      }
                      value={
                        values[
                          fields
                            .disregardYearsOfServiceAfterHowManyBreakInService
                        ]
                      }
                      type="number"
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInputNumber}
                      min={0}
                      max={99}
                      isRequired
                    />
                  )}
                  {values[fields.breakInServiceRules] === 3 && (
                    <Field
                      size="sm"
                      name={
                        fields.freezeVestingPercentageAfterHowManyBreakInService
                      }
                      type="number"
                      label={
                        "Freeze Vesting Percentage after how many consecutive breaks in service"
                      }
                      value={
                        values[
                          fields
                            .freezeVestingPercentageAfterHowManyBreakInService
                        ]
                      }
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInputNumber}
                      min={0}
                      max={99}
                      isRequired
                    />
                  )} */}

                    <Field
                      isRequired
                      name={fields.forfeitureFundIn}
                      label={"Allocate forfeiture fund in"}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.FORFEITURE_FUNDIN
                      )}
                      selectedValue={values[fields.forfeitureFundIn]}
                      value={values[fields.forfeitureFundIn]}
                      onChange={(value) => {
                        setFieldValue(fields.forfeitureFundIn, value);
                      }}
                      component={FieldButtonGroup}
                      disabled={isEdit && !isSave}
                      size="smd"
                    />

                    <Field
                      size="md"
                      label="Timing of Forfeitures"
                      name={fields.forfeitureTimings}
                      value={values[fields.forfeitureTimings]}
                      disabled={isEdit && !isSave}
                      options={timingForfeitures.data}
                      popupContent={
                        <SearchableList
                          label="Select a Timing of Forfeitures"
                          isNotTypeAhead
                          options={timingForfeitures.data}
                          onSelect={(value) =>
                            setFieldValue(fields.forfeitureTimings, value)
                          }
                          selectedValue={values[fields.forfeitureTimings]}
                          isRadio
                        />
                      }
                      component={FieldDropSide}
                      isRequired
                    />
                    <Field
                      size="lg"
                      name={fields.forfeitureTreatment}
                      label={"Forfeiture Treatment"}
                      options={forfeitureTreatment}
                      selectedValue={values[fields.forfeitureTreatment]}
                      onChange={(value) => {
                        setFieldValue(fields.forfeitureTreatment, value);
                      }}
                      component={FieldMultiSelectButtonGroup}
                      disabled={isEdit && !isSave}
                      isRequired
                    />
                    <Field
                      size="md"
                      label="Default Investment (for Forfeitures)"
                      name={fields.defaultInvestmentId}
                      value={values[fields.defaultInvestmentId]}
                      disabled={isEdit && !isSave}
                      options={investmentsList}
                      popupContent={
                        <SearchableList
                          label="Select a Default Investment"
                          isNotTypeAhead
                          options={investmentsList}
                          onSelect={(value) =>
                            setFieldValue(fields.defaultInvestmentId, value)
                          }
                          selectedValue={values[fields.defaultInvestmentId]}
                          isRadio
                        />
                      }
                      component={FieldDropSide}
                      isRequired
                    />
                    <div className="line-separator"></div>
                  </>
                )}
                <div className="d-flex justify-content-between bg-title">
                  <div>
                    <h4 className="ft-20">Additional Vesting Rules</h4>
                  </div>
                  <div>
                    <Link>
                      <AddButton
                        menu="plan"
                        subMenu="vesting"
                        disabled={isEdit && !isSave}
                        onAddClick={addVestingRuleClick}
                      />
                    </Link>
                  </div>
                </div>

                {isEmpty(additionalVestingsData) && (
                  <AddPlans
                    menu="plan"
                    subMenu="vesting"
                    content="No additional rules"
                    buttonLabel="ADD ADDITIONAL VESTING RULE"
                    className="h-auto"
                    disabled={isEdit && !isSave}
                    onPrimaryClick={addVestingRuleClick}
                  />
                )}
                {!isEmpty(additionalVestingsData) && (
                  <div className="w-100">
                    <Table>
                      <Table.Thead>
                        <Table.Tr>
                          {columns.map((item, index) => {
                            return (
                              <Table.Th key={index} className={item.className}>
                                {item.label}
                              </Table.Th>
                            );
                          })}
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {additionalVestingsData
                          .filter((additionalVesting) => {
                            return (
                              additionalVesting?.isDeleted === false ||
                              additionalVesting?.isDeleted === undefined
                            );
                          })
                          .map((additionalVesting, index) => {
                            return (
                              <Table.Tr key={index}>
                                {columns.map((item, cellIndex) => {
                                  return (
                                    <Table.Td
                                      key={cellIndex}
                                      className={item.className}
                                    >
                                      {!isEmpty(item.link) ? (
                                        <Link
                                          onClick={() => {
                                            editVestingRuleClick(item, index);
                                          }}
                                        >
                                          {additionalVesting[item.columnName]}
                                        </Link>
                                      ) : item.dataMapper ? (
                                        item.dataMapper[
                                          additionalVesting[item.columnName]
                                        ]
                                      ) : (
                                        additionalVesting[item.columnName]
                                      )}
                                    </Table.Td>
                                  );
                                })}
                              </Table.Tr>
                            );
                          })}
                      </Table.Tbody>
                    </Table>
                  </div>
                )}
              </ManagePlanLayout>
              <DeleteWarning
                DeleteToastMessageHead={DeleteToastMessageHead}
                DeleteToastMessage={DeleteToastMessage}
                showModal={showWarning}
                handleConfirmClick={handleConfirmClick}
                handleCancelClick={handleCancelClick}
              />
              <Modal show={showErrorModal} onHide={handleClose}>
                <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                  <div className="text-right">
                    <FontAwesomeIcon
                      icon={faTimes}
                      color="#000"
                      onClick={handleClose}
                    />
                  </div>
                  <div className="d-flex">
                    <div className="pd-15">
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        color="#f94f50"
                        size="3x"
                      />
                    </div>
                    <div className="remove-text">
                      <p>{errorMsg}</p>
                      <br />
                      <Button className="cancel-btn" onClick={handleClose}>
                        Ok
                      </Button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AddVestingContainer;
